// src/components/store/sections/weekly-banner/WeeklyBannerV103VinylportalLimeZest.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV103VinylportalLimeZest(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={103}
      archKey="vinyl_portal"
      archLabel="Circular Vinyl Portal"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      {...props}
    />
  );
}
